import { Navigate, useLocation } from "react-router";

export function SafeRedirect({to}:{to:string}) {
  const location = useLocation();
  return <Navigate to={`${to}${location.search}`} replace />;
}